<template>
  <client-groups :customer="customer" />
</template>

<script>
import ClientGroups from './ClientGroups';

export default {

  name: 'ClientGroupContainer',
  components: {
    ClientGroups,
  },
  data() {
    return {};
  },
  computed: {
    customer() {
      return this.$store.state.customers.item;
    },
  },
};
</script>

<style lang="css" scoped>
</style>
